document.addEventListener('DOMContentLoaded', function() {

  // CURSOR
  var cur = document.getElementById('cur');
  var curR = document.getElementById('cur-r');
  if (cur && curR) {
    var mx=0,my=0,rx=0,ry=0;
    document.addEventListener('mousemove',function(e){mx=e.clientX;my=e.clientY;});
    (function loop(){
      cur.style.left=mx+'px';cur.style.top=my+'px';
      rx+=(mx-rx)*0.12;ry+=(my-ry)*0.12;
      curR.style.left=rx+'px';curR.style.top=ry+'px';
      requestAnimationFrame(loop);
    })();
    document.addEventListener('mouseover',function(e){
      if(e.target.closest('a,button,.p-card')){cur.style.width='14px';cur.style.height='14px';curR.style.width='52px';curR.style.height='52px';}
    });
    document.addEventListener('mouseout',function(e){
      if(e.target.closest('a,button,.p-card')){cur.style.width='6px';cur.style.height='6px';curR.style.width='32px';curR.style.height='32px';}
    });
  }

  // NAV SCROLL
  var nav = document.querySelector('nav');
  var announce = document.querySelector('.announce');
  if (nav) {
    var ah = announce ? announce.offsetHeight : 0;
    window.addEventListener('scroll',function(){nav.classList.toggle('scrolled',window.scrollY>ah+10);});
  }

  // REVEAL
  var revEls = document.querySelectorAll('.reveal');
  if (revEls.length && 'IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(e){if(e.isIntersecting)e.target.classList.add('on');});
    },{threshold:0.08,rootMargin:'0px 0px -50px 0px'});
    revEls.forEach(function(el){obs.observe(el);});
  }

  // PRODUCT GALLERY THUMBS
  document.querySelectorAll('.pd-thumb').forEach(function(btn){
    btn.addEventListener('click',function(){
      var img=document.getElementById('pd-main-image');
      if(img){img.src=btn.dataset.src;img.alt=btn.dataset.alt||'';}
      document.querySelectorAll('.pd-thumb').forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
    });
  });

  // PRODUCT QTY
  var qtyNum = document.querySelector('.pd-qty-num');
  var qtyInput = document.getElementById('qty-input');
  var qtyMinus = document.querySelector('.qty-minus');
  var qtyPlus = document.querySelector('.qty-plus');
  if (qtyNum) {
    if(qtyMinus)qtyMinus.addEventListener('click',function(){var v=Math.max(1,parseInt(qtyNum.textContent)-1);qtyNum.textContent=v;if(qtyInput)qtyInput.value=v;});
    if(qtyPlus)qtyPlus.addEventListener('click',function(){var v=parseInt(qtyNum.textContent)+1;qtyNum.textContent=v;if(qtyInput)qtyInput.value=v;});
  }

  // VARIANT SELECTOR
  document.querySelectorAll('.pd-opt-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var pos=btn.dataset.option;
      document.querySelectorAll('.pd-opt-btn[data-option="'+pos+'"]').forEach(function(b){b.classList.remove('active');});
      btn.classList.add('active');
      updateVariant();
    });
  });

  function updateVariant(){
    var data=window.__variantData;if(!data)return;
    var sel={};
    document.querySelectorAll('.pd-opt-btn.active').forEach(function(b){sel[b.dataset.option]=b.dataset.value;});
    var variant=data.find(function(v){return v.options.every(function(o,i){return sel[String(i+1)]===o;});});
    if(variant){
      var vid=document.getElementById('variant-id');if(vid)vid.value=variant.id;
      // Update price
      var pel=document.querySelector('.pd-price');
      if(pel){
        var p='$'+(variant.price/100).toFixed(2);
        var ch=variant.compare_at_price>variant.price?'<span class="pd-compare">$'+(variant.compare_at_price/100).toFixed(2)+'</span> ':'';
        pel.innerHTML=ch+p;
      }
      // Update availability
      var abtn=document.querySelector('.pd-add');
      if(abtn){abtn.disabled=!variant.available;var sp=abtn.querySelector('span');if(sp)sp.textContent=variant.available?'Add to Cart':'Sold Out';}
      // Swap image if this variant has its own image
      if(variant.featured_image){
        var mainImg=document.getElementById('pd-main-image');
        if(mainImg){
          mainImg.src=variant.featured_image.src;
          mainImg.alt=variant.featured_image.alt||'';
        }
        // Also highlight the matching thumbnail
        document.querySelectorAll('.pd-thumb').forEach(function(btn){
          if(btn.dataset.src && btn.dataset.src.indexOf(variant.featured_image.src.split('?')[0].split('/').pop().split('.')[0]) !== -1){
            document.querySelectorAll('.pd-thumb').forEach(function(b){b.classList.remove('active');});
            btn.classList.add('active');
          }
        });
      }
    }
  }

  // AJAX ADD TO CART
  var pform=document.getElementById('product-form');
  if(pform){
    pform.addEventListener('submit',async function(e){
      e.preventDefault();
      var abtn=pform.querySelector('.pd-add');
      var sp=abtn&&abtn.querySelector('span');
      var orig=sp?sp.textContent:'Add to Cart';
      if(abtn){abtn.disabled=true;if(sp)sp.textContent='Adding...';}
      try{
        var variantId=document.getElementById('variant-id').value;
        var qty=parseInt(document.getElementById('qty-input').value)||1;
        var res=await fetch('/cart/add.js',{
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({id:variantId,quantity:qty})
        });
        var json=await res.json();
        if(json.id){
          var cr=await fetch('/cart.js');var cart=await cr.json();
          var cc=document.getElementById('cart-count');if(cc)cc.textContent=cart.item_count;
          showToast('\u271D "'+json.product_title+'" Added to Cart');
          if(sp)sp.textContent='\u271D Added!';
          setTimeout(function(){if(abtn){abtn.disabled=false;if(sp)sp.textContent=orig;}},2000);
        } else {
          // If there's an error message from Shopify
          var msg=json.description||json.message||'Could not add to cart';
          showToast(msg);
          if(abtn){abtn.disabled=false;if(sp)sp.textContent=orig;}
        }
      }catch(err){
        console.error('Cart error:',err);
        if(abtn){abtn.disabled=false;if(sp)sp.textContent=orig;}
      }
    });
  }

  // CART QTY — AJAX update
  document.querySelectorAll('.cart-qty-minus, .cart-qty-plus').forEach(function(btn){
    btn.addEventListener('click', async function(){
      var line = parseInt(btn.dataset.line);
      var displayEl = document.getElementById('qty-display-' + line);
      var inputEl = document.getElementById('updates_' + line);
      if (!displayEl || !inputEl) return;
      var current = parseInt(displayEl.textContent);
      var newQty = btn.classList.contains('cart-qty-minus') ? Math.max(0, current - 1) : current + 1;
      displayEl.textContent = newQty;
      inputEl.value = newQty;
      try {
        var res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({line: line, quantity: newQty})
        });
        var cart = await res.json();
        // Update cart count in nav
        var cc = document.getElementById('cart-count');
        if (cc) cc.textContent = cart.item_count;
        // Update subtotal
        var sub = document.getElementById('cart-subtotal');
        if (sub) sub.textContent = formatMoney(cart.total_price);
        // If item removed, reload page
        if (newQty === 0) window.location.reload();
      } catch(err){ console.error('Cart update error:', err); }
    });
  });

  // CART REMOVE — AJAX
  document.querySelectorAll('.cart-remove').forEach(function(btn){
    btn.addEventListener('click', async function(){
      var variantId = btn.dataset.variant;
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json'},
          body: JSON.stringify({id: variantId, quantity: 0})
        });
        window.location.reload();
      } catch(err){ console.error('Remove error:', err); }
    });
  });

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // TOAST
  window.showToast=function(msg){
    var t=document.getElementById('cart-toast');if(!t)return;
    t.textContent=msg;t.classList.add('show');
    setTimeout(function(){t.classList.remove('show');},2800);
  };

});

  // MOBILE NAV
  var hamburger = document.getElementById('nav-hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileOverlay = document.getElementById('mobile-nav-overlay');
  function openMobileNav() {
    hamburger.classList.add('open');
    mobileNav.classList.add('open');
    mobileOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobileNav() {
    hamburger.classList.remove('open');
    mobileNav.classList.remove('open');
    mobileOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }
  if (hamburger) {
    hamburger.addEventListener('click', function() {
      if (mobileNav.classList.contains('open')) closeMobileNav();
      else openMobileNav();
    });
  }
  if (mobileOverlay) mobileOverlay.addEventListener('click', closeMobileNav);
  document.querySelectorAll('.mobile-nav-links a').forEach(function(a) {
    a.addEventListener('click', closeMobileNav);
  });
